export default __webpack_public_path__ + "static/media/phapoom_img8.c3abe311.webp";